import API from "../app/api";

export const GetMegaMenuCategories = async () => {
    try {
        const { data } = await API.get("/menu/categories");

        if (!data?.success) {
            throw new Error(data?.message || "Failed to mega Menu Listing");
        }

        return data?.data?.categories || [];
    } catch (error) {
        // Handle axios error properly
        const errorMessage =
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong while fetching mega Menu";

        throw new Error(errorMessage);
    }
};